/**
 * Resolves the value sent as the downstream `cmp` header.
 * Legacy URL param `cmp` takes priority over `internal_source`.
 */
export function resolveCmpForApiFromQuery(
  query?: Record<string, string | string[] | undefined> | null
): string {
  if (!query) {
    return "";
  }
  const pick = (key: string) => {
    const v = query[key];
    if (typeof v === "string" && v !== "") {
      return v;
    }
    return "";
  };
  return pick("cmp") || pick("internal_source");
}

/** Prefer an explicit `cmp` from request data, then URL query (`cmp` then `internal_source`). */
export function resolveCmpForApiRequest(
  cmp: string | undefined,
  query?: Record<string, string | string[] | undefined> | null
): string {
  if (typeof cmp === "string" && cmp !== "") {
    return cmp;
  }
  return resolveCmpForApiFromQuery(query);
}

const INTERNAL_SOURCE_STORAGE_KEY = "internal_source";
const LEGACY_CMP_STORAGE_KEY = "cmp";

/**
 * Client-side: URL `cmp` > URL `internal_source` > session `internal_source` > legacy session `cmp` > query > fallback.
 */
export function getCmpHeaderValueForClient(
  query?: Record<string, string | string[] | undefined>,
  fallback = "fallback"
): string {
  if (typeof window !== "undefined") {
    const sp = new URLSearchParams(window.location.search);
    const cmpUrl = sp.get("cmp");
    if (cmpUrl) {
      return cmpUrl;
    }
    const internalUrl = sp.get("internal_source");
    if (internalUrl) {
      return internalUrl;
    }
  }
  if (typeof window !== "undefined") {
    const internal = sessionStorage.getItem(INTERNAL_SOURCE_STORAGE_KEY);
    if (internal) {
      return internal;
    }
    const legacy = sessionStorage.getItem(LEGACY_CMP_STORAGE_KEY);
    if (legacy) {
      return legacy;
    }
  }
  const fromQuery = resolveCmpForApiFromQuery(query);
  if (fromQuery) {
    return fromQuery;
  }
  return fallback;
}
